export const fonts = [
  { label: 'M PLUS Rounded 1c', value: '"M PLUS Rounded 1c", sans-serif' },
  {
    label: 'ヒラギノ丸ゴシック',
    value: '"ヒラギノ丸ゴ Pro W4", "ヒラギノ丸ゴ Pro", "Hiragino Maru Gothic Pro", sans-serif',
  },
];

export const heartShapes = [
  { color: '#FF4081', label: 'ピンクハート' },
  { color: '#E040FB', label: '紫ハート' },
  { color: '#FF1744', label: '赤ハート' },
  { color: '#00E676', label: '緑ハート' },
  { color: '#FFD600', label: '黄ハート' },
];

export const heartSizes = [
  { label: '小', value: 32 },
  { label: '中', value: 48 },
  { label: '大', value: 80 },
  { label: '特', value: 120 },
  { label: '極', value: 160 },
];

export const decoShapes = [
  { shape: 'heart', label: 'ハート', color: '#FF4081' },
  { shape: 'star', label: '星', color: '#FFD600' },
  { shape: 'note', label: '音符', color: '#00B0FF' },
  { shape: 'sparkle', label: 'キラキラ', color: '#E040FB' },
  { shape: 'circle', label: '丸', color: '#00E676' },
];

export const fillModes = [
  { value: 'none', label: '塗りなし' },
  { value: 'rounded', label: '角丸背景' },
  { value: 'all', label: '全塗り' },
];
